export default "__VITE_ASSET__1c967d6c__"